import { z } from 'zod';
import { interestPolicies } from '../../../types';

// Define schema for annuity frequency
const AnnuintyFrequencySchema = z.object({
  unit: z.enum(['months', 'years']).nullable().optional(),
  period: z.number().nullable().optional(),
});

// Define schema for opening
const OpeningSchema = z.object({
  application_document: z.enum(['not_applicable', 'required', 'optional', 'digital']),
  minimum_amount: z.string().nullable(),
});

// Define schema for termination
const TerminationSchema = z.object({
  notice_period: z
    .object({
      unit: z.enum(['days', 'weeks', 'months', 'years']).nullable().optional(),
      period: z.number().nullable().optional(),
    })
    .nullable()
    .optional()
    .transform((value) => {
      if (!value || !value.period || !value.unit) {
        return null;
      }
      return {
        unit: value.unit,
        period: value.period,
      };
    }),
  statutory_termination_timeframe: z.number(),
  contractual_termination_allowed: z.boolean(),
  interest_policy: z
    .enum([interestPolicies.PRO_RATA_BOOKED_AT_CURRENT_PLACEMENT_RATE, interestPolicies.NOT_BOOKED])
    .optional(),
});

// Define schema for renewal
const RenewalSchema = z.object({
  enabled: z.boolean(),
  default_product: z.string().nullable(),
  interest_capitalization: z
    .enum(['capitalize_interest', 'payout_interest', 'customer_preference'])
    .nullable(),
});

// Define schema for conditions
export const ConditionsSchema = z.object({
  minimum_balance: z.string(),
  maximum_balance: z.string(),
  annuity: z.object({
    frequency: AnnuintyFrequencySchema.nullish(),
    enabled: z.boolean(),
    point_of_reference: z.enum(['ABSOLUTE', 'RELATIVE']).nullish(),
    annuity_payout: z.boolean(),
    compound_interest: z.boolean(),
  }),
  opening: OpeningSchema,
  top_up: z.object({
    enabled: z.boolean(),
    minimum_amount: z.string().nullable(),
  }),
  withdrawal: z.object({
    enabled: z.boolean(),
    minimum_amount: z.string().nullable(),
  }),
  termination: TerminationSchema,
  renewal: RenewalSchema,
  settlement_day: z.array(
    z.enum(['SUNDAY', 'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY']),
  ),
  daily_settlement: z.boolean(),
});
